module.exports = __webpack_public_path__ + "static/img/none-data.889b4cfb.svg";